import * as React from 'react';

const ChevronDownDropdownChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        className="chevron-down-dropdown-chunky_svg__eds-icon--chevron-down-dropdown_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            className="chevron-down-dropdown-chunky_svg__eds-icon--chevron-down-dropdown_outside"
            d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
            fill="#39364F"
        />
        <path
            className="chevron-down-dropdown-chunky_svg__eds-icon--chevron-down-dropdown_inside"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7 10.27l5 4.937 5-4.937-1.414-1.397L12 12.414l-3.585-3.54L7 10.27z"
            fill="#fff"
        />
    </svg>
);

ChevronDownDropdownChunkySvg.displayName = 'ChevronDownDropdownChunkySvg';
export default ChevronDownDropdownChunkySvg;
